module.exports = __webpack_public_path__ + "static/img/google.3bae40f3.png";